import { SupportedMediaTypeDataEnum } from '@ysura/common';

import { createEnumMapperFunction } from '@/services/graphql/mappers/utils';
import { SupportedMediaType } from '@/services/graphql/types';

export const mapperSupportedMediaTypeDataEnum = createEnumMapperFunction(
  SupportedMediaType,
  SupportedMediaTypeDataEnum
);
